import { IDBConfiguration, ObjectStoreMeta } from './types';

export const INDEXED_DB_CONFIGURATION: IDBConfiguration = {
  dbName: 'store',
  version: 1,
};

export const objectStores: ObjectStoreMeta[] = [
  { store: 'defaultChannel' },
  { store: 'filterCampaign' },
  { store: '' },
];

// REFERENCE FOR INDEXED DB STORE
// {
//   store: 'analytics',
//   storeConfig: {
//     autoIncrement: true,
//     keyPath: 'analytics',
//   },
//   storeSchema: [
//     {
//       name: 'defaultSource',
//       keypath: 'defaultSource',
//       options: {
//         unique: false,
//       },
//     },
//     {
//       name: 'social',
//       keypath: 'social',
//       options: {
//         unique: false,
//       },
//     },
//     {
//       name: 'ads',
//       keypath: 'ads',
//       options: {
//         unique: false,
//       },
//     },
//     {
//       name: 'email',
//       keypath: 'email',
//       options: {
//         unique: false,
//       },
//     },
//     {
//       name: 'website',
//       keypath: 'website',
//       options: {
//         unique: false,
//       },
//     },
//   ],
// },
